/*
 * header — Kawaicafe
 * 1) Caret "|" parpadeando como placeholder del buscador (sin palabras).
 * 2) Drawer de menú móvil (burger + overlay + Esc).
 * 3) Sombra del header al hacer scroll.
 */
(function () {
  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Placeholder "BUSCAR" + caret "|" parpadeando --------------------------
  function blinkCaret(input) {
    if (!input) return;
    var base = input.getAttribute('data-search-caret') || input.getAttribute('placeholder') || '';
    // Sin animación si el usuario pide reducir movimiento: caret fijo.
    if (reduce) {
      input.setAttribute('placeholder', base + '|');
      return;
    }
    var on = true;
    setInterval(function () {
      // Mientras se escribe o está enfocado, solo el texto base.
      if (document.activeElement === input || input.value) {
        input.setAttribute('placeholder', base);
        return;
      }
      on = !on;
      input.setAttribute('placeholder', on ? base + '|' : base);
    }, 530);
  }

  // 2) Drawer móvil ---------------------------------------------------------
  function initDrawer(header) {
    if (header.dataset.khDrawerInit) return;
    header.dataset.khDrawerInit = '1';
    var toggle = header.querySelector('[data-kh-toggle]');
    var overlay = header.querySelector('[data-kh-overlay]');
    var drawer = header.querySelector('[data-kh-drawer]');
    if (!toggle || !drawer) return;
    // CLAVE: el drawer y el overlay son position:fixed, pero el header sticky
    // añade backdrop-filter al hacer scroll (is-scrolled) y ESO crea un
    // containing block que atrapa los fixed → el menú solo cubría la caja del
    // header (se veía "solo al principio de la página"). Moviéndolos al <body>
    // quedan siempre relativos al viewport y cubren toda la pantalla haya o no
    // scroll. El estado se marca en <body> para que los selectores sigan valiendo.
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    if (overlay && overlay.parentNode !== document.body) document.body.appendChild(overlay);

    // El bloqueo de scroll va en el elemento RAIZ, no en el <body>: base.scss
    // declara `html{overflow-x:clip}` y con la raiz en un overflow distinto de
    // `visible` el `overflow:hidden` del body YA NO se propaga al viewport, asi
    // que la pagina seguia desplazandose al arrastrar sobre el propio menu.
    // Atributo propio (no una clase compartida) para no pisarse con el pop-up
    // de ciudades, que tambien bloquea.
    function open() {
      // La tarjeta se alinea a la PILDORA real en el momento de abrir (top,
      // izquierda, ancho y alto de la fila): asi "sale del header flotante"
      // en cualquier posicion de scroll y en cualquier ancho.
      var inner = header.querySelector('.kawaii-header__inner');
      if (inner) {
        var r = inner.getBoundingClientRect();
        drawer.style.setProperty('--kh-card-top', r.top + 'px');
        drawer.style.setProperty('--kh-card-left', r.left + 'px');
        drawer.style.setProperty('--kh-card-w', r.width + 'px');
        drawer.style.setProperty('--kh-card-h', r.height + 'px');
      }
      document.body.classList.add('kh-menu-open');
      document.documentElement.setAttribute('data-menu-open', '');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
    }
    function close() {
      document.body.classList.remove('kh-menu-open');
      document.documentElement.removeAttribute('data-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    }
    toggle.addEventListener('click', function () {
      document.body.classList.contains('kh-menu-open') ? close() : open();
    });
    if (overlay) overlay.addEventListener('click', close);
    var closeBtn = drawer.querySelector('[data-kh-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', close);
    });
  }

  // 3) Sombra al scroll -----------------------------------------------------
  function initScroll(header) {
    if (!header.classList.contains('kawaii-header--sticky')) return;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    document.querySelectorAll('[data-search-caret]').forEach(blinkCaret);
    document.querySelectorAll('[data-kh]').forEach(function (h) {
      initDrawer(h);
      initScroll(h);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('[data-kh]');
    if (h) {
      blinkCaret(h.querySelector('[data-search-caret]'));
      initDrawer(h);
      initScroll(h);
    }
  });
})();
